// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { HealthControllerHealthData, HealthControllerHealthResponses, AuthControllerLoginData, AuthControllerLoginResponses, AuthControllerLogoutData, AuthControllerLogoutResponses, AuthControllerStopImpersonatingData, AuthControllerStopImpersonatingResponses, AuthControllerDeleteData, AuthControllerDeleteResponses, OrganizationControllerGetData, OrganizationControllerGetResponses, OrganizationControllerUpdateSettingsData, OrganizationControllerUpdateSettingsResponses, ProductControllerListData, ProductControllerListResponses, ProductControllerGetData, ProductControllerGetResponses, ProductControllerGetImagesData, ProductControllerGetImagesResponses, ProductControllerSetAttentionData, ProductControllerSetAttentionResponses, ProductControllerSetImageAttentionData, ProductControllerSetImageAttentionResponses, ProductControllerDeleteData, ProductControllerDeleteResponses, ProductControllerDeleteImageData, ProductControllerDeleteImageResponses, LogControllerTestData, LogControllerTestResponses, LogControllerFailData, LogControllerFailResponses, AdminUserControllerListData, AdminUserControllerListResponses, AdminOrganizationControllerListData, AdminOrganizationControllerListResponses, AdminDeviceSessionsControllerListData, AdminDeviceSessionsControllerListResponses, AdminDeviceSessionsControllerStatsData, AdminDeviceSessionsControllerStatsResponses, AppControllerChallengeData, AppControllerChallengeResponses, AppControllerGetVersionInfoData, AppControllerGetVersionInfoResponses, AppControllerVerifyAttestationData, AppControllerVerifyAttestationResponses, AppControllerGetAvailableCreditsData, AppControllerGetAvailableCreditsResponses, AppControllerRedeemCodeData, AppControllerRedeemCodeResponses, AppControllerConfigData, AppControllerConfigResponses, AppControllerUploadImageVersionData, AppControllerUploadImageVersionResponses, AppControllerPushChangesData, AppControllerPushChangesResponses, AppControllerExportData, AppControllerExportResponses, AppControllerIntegrationsData, AppControllerIntegrationsResponses, ExportControllerGetImageData, ExportControllerGetImageResponses, ExportControllerListExportTasksData, ExportControllerListExportTasksResponses, ExportControllerGetExportErrorsData, ExportControllerGetExportErrorsResponses, ExportControllerCancelExportTaskData, ExportControllerCancelExportTaskResponses, ExportControllerDismissExportTaskData, ExportControllerDismissExportTaskResponses, WebarealControllerInstallData, WebarealControllerInstallResponses, ShoptetControllerInstallData, ShoptetControllerInstallResponses, ShoptetControllerVerifyCodeData, ShoptetControllerVerifyCodeResponses, ShoptetControllerInitiateConnectData, ShoptetControllerInitiateConnectResponses, ShoptetControllerFinishConnectData, ShoptetControllerFinishConnectResponses, ShoptetControllerDisconnectData, ShoptetControllerDisconnectResponses, ShoptetControllerListConnectionsData, ShoptetControllerListConnectionsResponses, ShoptetControllerWebhookData, ShoptetControllerWebhookResponses, ShoptetControllerGetSettingsData, ShoptetControllerGetSettingsResponses, ShoptetControllerUpdateSettingsData, ShoptetControllerUpdateSettingsResponses, DeprecatedProcessImageControllerPlusData, DeprecatedProcessImageControllerPlusResponses, DeprecatedProcessImageControllerBasicData, DeprecatedProcessImageControllerBasicResponses, DeprecatedProcessImageControllerApplyToolData, DeprecatedProcessImageControllerApplyToolResponses, DeprecatedProcessImageControllerAiMagicData, DeprecatedProcessImageControllerAiMagicResponses, DeprecatedProcessImageControllerExtractBookCoverData, DeprecatedProcessImageControllerExtractBookCoverResponses, UserControllerListData, UserControllerListResponses, UserControllerRemoveAccessData, UserControllerRemoveAccessResponses, UserControllerAddAccessData, UserControllerAddAccessResponses, ApiKeyControllerListData, ApiKeyControllerListResponses, ApiKeyControllerCreateData, ApiKeyControllerCreateResponses, ApiKeyControllerRemoveData, ApiKeyControllerRemoveResponses, UsageControllerGetLast31DaysUsageData, UsageControllerGetLast31DaysUsageResponses, UsageControllerGetLast3MonthsUsageData, UsageControllerGetLast3MonthsUsageResponses, ImageControllerDownloadAttentionImagesData, ImageControllerDownloadAttentionImagesResponses, ImageControllerUploadImagesData, ImageControllerUploadImagesResponses, ShoptetExternalProductControllerFetchExternalProductsData, ShoptetExternalProductControllerFetchExternalProductsResponses, ShoptetExternalProductControllerFetchExternalProductImagesData, ShoptetExternalProductControllerFetchExternalProductImagesResponses, ShoptetExternalProductControllerUploadExternalProductImageData, ShoptetExternalProductControllerUploadExternalProductImageResponses, ExternalProductControllerListData, ExternalProductControllerListResponses, ExternalProductControllerGetTagsData, ExternalProductControllerGetTagsResponses, ExternalProductControllerListImagesData, ExternalProductControllerListImagesResponses, ExternalProductControllerGetData, ExternalProductControllerGetResponses, ExternalProductControllerProcessImageData, ExternalProductControllerProcessImageResponses, ExternalProductControllerBulkActionData, ExternalProductControllerBulkActionResponses, ImageEditControllerRestartImageEditsData, ImageEditControllerRestartImageEditsResponses, ProcessingControllerGetPriceData, ProcessingControllerGetPriceResponses, ProcessingControllerProcessData, ProcessingControllerProcessResponses, V1ControllerFeedCsvData, V1ControllerFeedCsvResponses, V1ControllerFeedCsvErrors, V1ControllerFeedJsonData, V1ControllerFeedJsonResponses, V1ControllerFeedJsonErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const healthControllerHealth = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthControllerHealthResponses, unknown, ThrowOnError>({
        url: '/api/health',
        ...options
    });
};

export const authControllerLogin = <ThrowOnError extends boolean = false>(options: Options<AuthControllerLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthControllerLoginResponses, unknown, ThrowOnError>({
        url: '/api/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authControllerLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerLogoutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AuthControllerLogoutResponses, unknown, ThrowOnError>({
        url: '/api/auth/logout',
        ...options
    });
};

export const authControllerStopImpersonating = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerStopImpersonatingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AuthControllerStopImpersonatingResponses, unknown, ThrowOnError>({
        url: '/api/auth/stop-impersonating',
        ...options
    });
};

export const authControllerDelete = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<AuthControllerDeleteResponses, unknown, ThrowOnError>({
        url: '/api/auth/delete',
        ...options
    });
};

export const organizationControllerGet = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<OrganizationControllerGetResponses, unknown, ThrowOnError>({
        url: '/api/organizations/{id}',
        ...options
    });
};

export const organizationControllerUpdateSettings = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerUpdateSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<OrganizationControllerUpdateSettingsResponses, unknown, ThrowOnError>({
        url: '/api/organizations/{id}/update-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productControllerList = <ThrowOnError extends boolean = false>(options: Options<ProductControllerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductControllerListResponses, unknown, ThrowOnError>({
        url: '/api/products',
        ...options
    });
};

export const productControllerGet = <ThrowOnError extends boolean = false>(options: Options<ProductControllerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductControllerGetResponses, unknown, ThrowOnError>({
        url: '/api/products/{id}',
        ...options
    });
};

export const productControllerGetImages = <ThrowOnError extends boolean = false>(options: Options<ProductControllerGetImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductControllerGetImagesResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}/images',
        ...options
    });
};

export const productControllerSetAttention = <ThrowOnError extends boolean = false>(options: Options<ProductControllerSetAttentionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductControllerSetAttentionResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}/set-attention',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productControllerSetImageAttention = <ThrowOnError extends boolean = false>(options: Options<ProductControllerSetImageAttentionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductControllerSetImageAttentionResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}/images/{imageId}/set-attention',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productControllerDelete = <ThrowOnError extends boolean = false>(options: Options<ProductControllerDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProductControllerDeleteResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}',
        ...options
    });
};

export const productControllerDeleteImage = <ThrowOnError extends boolean = false>(options: Options<ProductControllerDeleteImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProductControllerDeleteImageResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}/images/{imageId}',
        ...options
    });
};

export const logControllerTest = <ThrowOnError extends boolean = false>(options?: Options<LogControllerTestData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LogControllerTestResponses, unknown, ThrowOnError>({
        url: '/api/log/test',
        ...options
    });
};

export const logControllerFail = <ThrowOnError extends boolean = false>(options?: Options<LogControllerFailData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LogControllerFailResponses, unknown, ThrowOnError>({
        url: '/api/log/fail',
        ...options
    });
};

export const adminUserControllerList = <ThrowOnError extends boolean = false>(options: Options<AdminUserControllerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AdminUserControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/users',
        ...options
    });
};

export const adminOrganizationControllerList = <ThrowOnError extends boolean = false>(options?: Options<AdminOrganizationControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminOrganizationControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/organizations',
        ...options
    });
};

export const adminDeviceSessionsControllerList = <ThrowOnError extends boolean = false>(options?: Options<AdminDeviceSessionsControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminDeviceSessionsControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/device-sessions',
        ...options
    });
};

export const adminDeviceSessionsControllerStats = <ThrowOnError extends boolean = false>(options?: Options<AdminDeviceSessionsControllerStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminDeviceSessionsControllerStatsResponses, unknown, ThrowOnError>({
        url: '/api/admin/device-sessions/stats',
        ...options
    });
};

export const appControllerChallenge = <ThrowOnError extends boolean = false>(options?: Options<AppControllerChallengeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AppControllerChallengeResponses, unknown, ThrowOnError>({
        url: '/api/app/challenge',
        ...options
    });
};

export const appControllerGetVersionInfo = <ThrowOnError extends boolean = false>(options?: Options<AppControllerGetVersionInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppControllerGetVersionInfoResponses, unknown, ThrowOnError>({
        url: '/api/app/version-info',
        ...options
    });
};

export const appControllerVerifyAttestation = <ThrowOnError extends boolean = false>(options: Options<AppControllerVerifyAttestationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerVerifyAttestationResponses, unknown, ThrowOnError>({
        url: '/api/app/verify-attestation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerGetAvailableCredits = <ThrowOnError extends boolean = false>(options: Options<AppControllerGetAvailableCreditsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerGetAvailableCreditsResponses, unknown, ThrowOnError>({
        url: '/api/app/available-credits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerRedeemCode = <ThrowOnError extends boolean = false>(options: Options<AppControllerRedeemCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerRedeemCodeResponses, unknown, ThrowOnError>({
        url: '/api/app/redeem-code',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerConfig = <ThrowOnError extends boolean = false>(options?: Options<AppControllerConfigData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppControllerConfigResponses, unknown, ThrowOnError>({
        url: '/api/app/config',
        ...options
    });
};

export const appControllerUploadImageVersion = <ThrowOnError extends boolean = false>(options: Options<AppControllerUploadImageVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerUploadImageVersionResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/app/upload-image-version',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const appControllerPushChanges = <ThrowOnError extends boolean = false>(options: Options<AppControllerPushChangesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerPushChangesResponses, unknown, ThrowOnError>({
        url: '/api/app/push-changes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerExport = <ThrowOnError extends boolean = false>(options: Options<AppControllerExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerExportResponses, unknown, ThrowOnError>({
        url: '/api/app/export',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerIntegrations = <ThrowOnError extends boolean = false>(options?: Options<AppControllerIntegrationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppControllerIntegrationsResponses, unknown, ThrowOnError>({
        url: '/api/app/integrations',
        ...options
    });
};

export const exportControllerGetImage = <ThrowOnError extends boolean = false>(options: Options<ExportControllerGetImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExportControllerGetImageResponses, unknown, ThrowOnError>({
        url: '/api/export/image/{imageVersionId}/{filename}',
        ...options
    });
};

export const exportControllerListExportTasks = <ThrowOnError extends boolean = false>(options?: Options<ExportControllerListExportTasksData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExportControllerListExportTasksResponses, unknown, ThrowOnError>({
        url: '/api/export/export-tasks',
        ...options
    });
};

export const exportControllerGetExportErrors = <ThrowOnError extends boolean = false>(options: Options<ExportControllerGetExportErrorsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExportControllerGetExportErrorsResponses, unknown, ThrowOnError>({
        url: '/api/export/export-tasks/{id}/errors',
        ...options
    });
};

export const exportControllerCancelExportTask = <ThrowOnError extends boolean = false>(options: Options<ExportControllerCancelExportTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExportControllerCancelExportTaskResponses, unknown, ThrowOnError>({
        url: '/api/export/export-tasks/{id}/cancel',
        ...options
    });
};

export const exportControllerDismissExportTask = <ThrowOnError extends boolean = false>(options: Options<ExportControllerDismissExportTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExportControllerDismissExportTaskResponses, unknown, ThrowOnError>({
        url: '/api/export/export-tasks/{id}/dismiss',
        ...options
    });
};

export const webarealControllerInstall = <ThrowOnError extends boolean = false>(options?: Options<WebarealControllerInstallData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<WebarealControllerInstallResponses, unknown, ThrowOnError>({
        url: '/api/integrations/webareal/install',
        ...options
    });
};

export const shoptetControllerInstall = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerInstallData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ShoptetControllerInstallResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/install',
        ...options
    });
};

export const shoptetControllerVerifyCode = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerVerifyCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerVerifyCodeResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/verify-code',
        ...options
    });
};

export const shoptetControllerInitiateConnect = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerInitiateConnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerInitiateConnectResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/initiate-connect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const shoptetControllerFinishConnect = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerFinishConnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerFinishConnectResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/finish-connect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const shoptetControllerDisconnect = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerDisconnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerDisconnectResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/disconnect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const shoptetControllerListConnections = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerListConnectionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerListConnectionsResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/connections',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const shoptetControllerWebhook = <ThrowOnError extends boolean = false>(options?: Options<ShoptetControllerWebhookData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ShoptetControllerWebhookResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/webhook',
        ...options
    });
};

export const shoptetControllerGetSettings = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerGetSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ShoptetControllerGetSettingsResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/settings/{integrationId}',
        ...options
    });
};

export const shoptetControllerUpdateSettings = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerUpdateSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ShoptetControllerUpdateSettingsResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/settings/{integrationId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerPlus = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerPlusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerPlusResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/plus',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerBasic = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerBasicData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerBasicResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/basic',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerApplyTool = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerApplyToolData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerApplyToolResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/apply-tool',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerAiMagic = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerAiMagicData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerAiMagicResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/ai-magic',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerExtractBookCover = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerExtractBookCoverData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerExtractBookCoverResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/extract-book-cover',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const userControllerList = <ThrowOnError extends boolean = false>(options?: Options<UserControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserControllerListResponses, unknown, ThrowOnError>({
        url: '/api/users',
        ...options
    });
};

export const userControllerRemoveAccess = <ThrowOnError extends boolean = false>(options: Options<UserControllerRemoveAccessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<UserControllerRemoveAccessResponses, unknown, ThrowOnError>({
        url: '/api/users/access',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const userControllerAddAccess = <ThrowOnError extends boolean = false>(options: Options<UserControllerAddAccessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserControllerAddAccessResponses, unknown, ThrowOnError>({
        url: '/api/users/access',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const apiKeyControllerList = <ThrowOnError extends boolean = false>(options?: Options<ApiKeyControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ApiKeyControllerListResponses, unknown, ThrowOnError>({
        url: '/api/api-keys',
        ...options
    });
};

export const apiKeyControllerCreate = <ThrowOnError extends boolean = false>(options: Options<ApiKeyControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiKeyControllerCreateResponses, unknown, ThrowOnError>({
        url: '/api/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const apiKeyControllerRemove = <ThrowOnError extends boolean = false>(options: Options<ApiKeyControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiKeyControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/api/api-keys/{id}',
        ...options
    });
};

export const usageControllerGetLast31DaysUsage = <ThrowOnError extends boolean = false>(options: Options<UsageControllerGetLast31DaysUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UsageControllerGetLast31DaysUsageResponses, unknown, ThrowOnError>({
        url: '/api/usage/last-31-days',
        ...options
    });
};

export const usageControllerGetLast3MonthsUsage = <ThrowOnError extends boolean = false>(options: Options<UsageControllerGetLast3MonthsUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UsageControllerGetLast3MonthsUsageResponses, unknown, ThrowOnError>({
        url: '/api/usage/last-3-months',
        ...options
    });
};

export const imageControllerDownloadAttentionImages = <ThrowOnError extends boolean = false>(options?: Options<ImageControllerDownloadAttentionImagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ImageControllerDownloadAttentionImagesResponses, unknown, ThrowOnError>({
        url: '/api/images/download-attention-images',
        ...options
    });
};

export const imageControllerUploadImages = <ThrowOnError extends boolean = false>(options?: Options<ImageControllerUploadImagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ImageControllerUploadImagesResponses, unknown, ThrowOnError>({
        url: '/api/images/upload',
        ...options
    });
};

export const shoptetExternalProductControllerFetchExternalProducts = <ThrowOnError extends boolean = false>(options?: Options<ShoptetExternalProductControllerFetchExternalProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ShoptetExternalProductControllerFetchExternalProductsResponses, unknown, ThrowOnError>({
        url: '/api/external-products/shoptet-external-product/fetch-external-products',
        ...options
    });
};

export const shoptetExternalProductControllerFetchExternalProductImages = <ThrowOnError extends boolean = false>(options?: Options<ShoptetExternalProductControllerFetchExternalProductImagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ShoptetExternalProductControllerFetchExternalProductImagesResponses, unknown, ThrowOnError>({
        url: '/api/external-products/shoptet-external-product/fetch-external-product-images',
        ...options
    });
};

export const shoptetExternalProductControllerUploadExternalProductImage = <ThrowOnError extends boolean = false>(options: Options<ShoptetExternalProductControllerUploadExternalProductImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetExternalProductControllerUploadExternalProductImageResponses, unknown, ThrowOnError>({
        url: '/api/external-products/shoptet-external-product/upload-external-product-image/{id}',
        ...options
    });
};

export const externalProductControllerList = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExternalProductControllerListResponses, unknown, ThrowOnError>({
        url: '/api/external-products',
        ...options
    });
};

export const externalProductControllerGetTags = <ThrowOnError extends boolean = false>(options?: Options<ExternalProductControllerGetTagsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExternalProductControllerGetTagsResponses, unknown, ThrowOnError>({
        url: '/api/external-products/tags',
        ...options
    });
};

export const externalProductControllerListImages = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerListImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExternalProductControllerListImagesResponses, unknown, ThrowOnError>({
        url: '/api/external-products/images',
        ...options
    });
};

export const externalProductControllerGet = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExternalProductControllerGetResponses, unknown, ThrowOnError>({
        url: '/api/external-products/{id}',
        ...options
    });
};

export const externalProductControllerProcessImage = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerProcessImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExternalProductControllerProcessImageResponses, unknown, ThrowOnError>({
        url: '/api/external-products/process-image/{id}',
        ...options
    });
};

export const externalProductControllerBulkAction = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerBulkActionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExternalProductControllerBulkActionResponses, unknown, ThrowOnError>({
        url: '/api/external-products/bulk-action',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Restart failed image edit operations
 * Restarts image edit tasks that have errors and were started. Only selects tasks created from the specified date onwards.
 */
export const imageEditControllerRestartImageEdits = <ThrowOnError extends boolean = false>(options: Options<ImageEditControllerRestartImageEditsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImageEditControllerRestartImageEditsResponses, unknown, ThrowOnError>({
        url: '/api/image-edit/restart',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const processingControllerGetPrice = <ThrowOnError extends boolean = false>(options: Options<ProcessingControllerGetPriceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcessingControllerGetPriceResponses, unknown, ThrowOnError>({
        url: '/api/processing/price',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const processingControllerProcess = <ThrowOnError extends boolean = false>(options: Options<ProcessingControllerProcessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcessingControllerProcessResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/processing/process',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Get product feed as CSV
 * Retrieves a CSV feed of product images that were created or modified since a given date. Returns up to 10,000 rows with product codes, creation dates, and image URLs.
 */
export const v1ControllerFeedCsv = <ThrowOnError extends boolean = false>(options?: Options<V1ControllerFeedCsvData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<V1ControllerFeedCsvResponses, V1ControllerFeedCsvErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/feed-csv',
        ...options
    });
};

/**
 * Get product feed as JSON
 * Retrieves a JSON feed of product images that were created or modified since a given date. Returns up to 10,000 images grouped by product.
 */
export const v1ControllerFeedJson = <ThrowOnError extends boolean = false>(options?: Options<V1ControllerFeedJsonData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<V1ControllerFeedJsonResponses, V1ControllerFeedJsonErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/feed-json',
        ...options
    });
};